import { render, staticRenderFns } from "./brand_configuration.vue?vue&type=template&id=c05f2750&scoped=true"
import script from "./brand_configuration.vue?vue&type=script&lang=js"
export * from "./brand_configuration.vue?vue&type=script&lang=js"
import style0 from "./brand_configuration.vue?vue&type=style&index=0&id=c05f2750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05f2750",
  null
  
)

export default component.exports